import { gql } from '@apollo/client';

const CREDENTIALS = `
  credentials {
    accessToken
    client
    expiry
    tokenType
    uid
  }
`;

export const ACCEPT_INVITATION = gql`
  mutation PortalUserUpdatePasswordWithToken(
    $password: String!
    $passwordConfirmation: String!
    $invitationToken: String!
  ) {
    portalUserAcceptInvitation(
      password: $password
      passwordConfirmation: $passwordConfirmation
      invitationToken: $invitationToken
    ) {
      ${CREDENTIALS}
    }
  }
`;

export const LOGIN = gql`
  mutation PortalUserLogin(
    $email: String!
    $password: String!
  ) {
    portalUserLogin(
      email: $email
      password: $password
    ) {
      ${CREDENTIALS}
    }
  }
`;

export const SEND_PASSWORD_RESET = gql`
  mutation PortalUserSendPasswordResetWithToken(
    $email: String!
  ) {
    portalUserSendPasswordResetWithToken(
      email: $email
      redirectUrl: "https://fbo.flylouie.com"
    ) {
      message
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation PortalUserUpdatePasswordWithToken(
    $password: String!
    $passwordConfirmation: String!
    $resetPasswordToken: String!
  ) {
    portalUserUpdatePasswordWithToken(
      password: $password
      passwordConfirmation: $passwordConfirmation
      resetPasswordToken: $resetPasswordToken
    ) {
      ${CREDENTIALS}
    }
  }
`;
